function coupons(state = [], action) {
    switch (action.type) {
        case 'COUPONS/SET':
            return action.coupons;
        default:
            return state;
    }
}

export default coupons;
